import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import * as React from 'react';
import Mousetrap from 'mousetrap';
import Box from '../Box';
import Button from '../Button';
import Card from '../Card';
import Divider from '../Divider';
import StackView from '../StackView';

var _ref = /*#__PURE__*/React.createElement(Divider, null);

var _ref2 = /*#__PURE__*/React.createElement(Divider, null);

export function FilterLayout(props) {
  var header = props.header,
      _props$sidebarWidth = props.sidebarWidth,
      sidebarWidth = _props$sidebarWidth === void 0 ? 400 : _props$sidebarWidth,
      sidebar = props.sidebar,
      table = props.table,
      toolbar = props.toolbar,
      restProps = _objectWithoutPropertiesLoose(props, ["header", "sidebarWidth", "sidebar", "table", "toolbar"]);

  var fill = sidebarWidth === 'fill';

  var _React$useState = React.useState(false),
      sidebarOpen = _React$useState[0],
      setSidebarOpen = _React$useState[1];

  var toggleSidebar = React.useCallback(function () {
    setSidebarOpen(function (sidebarOpen) {
      return !sidebarOpen;
    });
  }, []);
  React.useEffect(function () {
    Mousetrap.bind('f', toggleSidebar);
    return function () {
      Mousetrap.unbind('f');
    };
  }, []);
  return /*#__PURE__*/React.createElement(Card, _extends({
    minHeight: 50,
    overflow: undefined
  }, restProps), /*#__PURE__*/React.createElement(StackView, {
    axis: "horizontal",
    minHeight: 6
  }, /*#__PURE__*/React.createElement(Button, {
    grow: 0,
    shrink: 0,
    basis: sidebarOpen ? fill ? '100%' : sidebarWidth + 'px' : '100px',
    distribution: sidebarOpen ? 'space-between' : undefined,
    width: "100%",
    paddingHorizontal: 2,
    borderRightWidth: 1,
    borderRightColor: "separatorTertiary",
    radius: 0,
    title: "Filter",
    "aria-label": sidebarOpen ? 'close filter' : 'open filter',
    iconRight: {
      name: sidebarOpen ? 'caret-left' : 'filter'
    },
    onClick: toggleSidebar
  }), /*#__PURE__*/React.createElement(Box, {
    visible: !(sidebarOpen && fill),
    grow: 1,
    shrink: 1
  }, header)), _ref, /*#__PURE__*/React.createElement(StackView, {
    axis: "horizontal",
    grow: 1
  }, /*#__PURE__*/React.createElement(StackView, {
    visible: sidebarOpen,
    basis: fill ? '100%' : sidebarWidth + 'px',
    borderRightWidth: 1,
    borderRightColor: "separatorTertiary",
    backgroundColor: "surfaceSecondary"
  }, sidebar), /*#__PURE__*/React.createElement(StackView, {
    visible: !(sidebarOpen && fill),
    grow: 1,
    shrink: 1,
    basis: "100%"
  }, toolbar, _ref2, table)));
}